<script>
	import {Vue} from "ui.vue";
	import {Events} from "../mixins/constant";
	import serverMixin from "../mixins/server";
	import stepsMixin from "../mixins/steps";
	import propertyMixin from "../mixins/property";
	import userDataMixin from "../mixins/userData";
	import metricMixin from "../mixins/metric";
	import preorderMixin from "../mixins/preorder";
	import popupMixin from "../mixins/popup";
	import {additionalProductMixin} from "../mixins/additionalProduct";

	import PopupBullets from "./PopupBullets.vue";
	import PopupAdditionalProduct from "./PopupAdditionalProduct.vue";
	import PopupChangeDeliveryTime from "./PopupChangeDeliveryTime.vue";

	export default {
		name: "Order",
		mixins:[
			popupMixin,
			additionalProductMixin,
			preorderMixin,
			metricMixin,
			serverMixin,
			stepsMixin,
			propertyMixin,
			userDataMixin
		],
		components: {
			PopupBullets,
			PopupAdditionalProduct,
			PopupChangeDeliveryTime
		},
		data() {
			return {
				result: [],
				params: {},
				comment: {
					TITLE: '',
					VALUE: '',
					TYPE: 'comment',
					CODE: 'comment'
				},
				OpenIndicator: {
					render: createElement => createElement('span', {
						class: {'select_toggle b-filter__icon': true},
						domProps: {
							innerHTML: '<i class="icon icon--arrow-down"></i>'
						},
					})
				},
				agreementLink: "",
				agreementChecked: false,
				subscriptionChecked: false,
				agreementShow: true,
				subscriptionShow: true,
				cutlery: [],
				paymentSelected: false,
				agreementError: false
			}
		},
		computed: {
			loc() {
				return Vue.getFilteredPhrases("SOA_");
			},
			cutleryList() {
				let cutleryList = [];

				for (let i = 0; i < this.cutlery.length; i++) {

					if(this.result.PREPARED_ITEMS.find(el => el['product_id'] == this.cutlery[i]['product_id'])) {
						continue;
					}

					cutleryList.push(this.cutlery[i]);
				}

				return cutleryList;
			}
		},
		mounted() {
			Vue.event.$on(Events.REFRESH, this.onRefresh);
			Vue.event.$on(Events.BASKET_CHANGED, this.onBasketChange)
		},
		beforeDestroy() {
			Vue.event.$off(Events.REFRESH, this.onRefresh);
			Vue.event.$off(Events.BASKET_CHANGED, this.onBasketChange)
		},
		created() {
			if (this.result && this.result.IIKO_DELIVERY_TIME) {
				this.pickupDeliveryTime = this.result.IIKO_DELIVERY_TIME.PICKUP_TIME_VALUE
					? this.result.IIKO_DELIVERY_TIME.PICKUP_TIME_VALUE
					: false;
			}

			this.__init();
			this.__initStep();
			this.__initPreOrderData();
			this.__initAdditionalProductData();

			BX.addCustomEvent('changeDeliveryTimeFromButton', (result) => {
				this.setDeliveryTimePropertyValues(result);
			});
		},
		methods: {
			agreementErrorChange() {
				this.$nextTick(function() {
					this.agreementError = !this.agreementChecked;
					if(this.agreementChecked !== true) {
						console.error("Нет согласия на обработку персональных данных");
					}
				})
			},
			onRefresh(params) {
				this.onAjaxRequest(params);
			},
			onBasketChange() {
				this.onAjaxRequest();
			},
			__init() {
				console.log(this.fieldProps);
				if (this.result.IIKO_DELIVERY_TIME) {
					this.$store.dispatch('basket/setOrderStock', this.result.IIKO_DELIVERY_TIME.stock);
					this.$store.dispatch('basket/setExcludedDates', this.result.IIKO_DELIVERY_TIME.EXCLUDED_DATES);
				}

				this.__preparePropertyList(this.result.ORDER_PROP.groups, this.result.ORDER_PROP.properties);
				this.comment.VALUE = this.result.ORDER_DESCRIPTION ? this.result.ORDER_DESCRIPTION : "";
				this.__initUserData();
			}
		},
	}
</script>